import React, { useState, useEffect } from 'react';
import { LoadingIndicator, TableCellAlign } from 'react-magma-dom';
import PropTypes from 'prop-types';
import AccordionTable from 'components/AccordionTable';
import ImportButton from './ImportButton';
import HiddenColumns from './HiddenColumns';
import { hiddenColumns, order, IMPORT, PEDAGOGICAL_NOTES, N } from './Constants';
import { sanitizeAllHTML } from 'utilities/index.js';

const DatasetTable = props => {
  const { data, onChange, message } = props;
  const [dataSets, setDataSets] = useState(data);
  useEffect(() => setDataSets(data), [data]);

  useEffect(() => {
    if (message.length > 0) {
      const filterDatasets = data.filter(dataSet => {
        const filteringData = [dataSet.name, dataSet.description, dataSet.interest_tag, dataSet.teaching_tag, dataSet.pednotes];

        return filteringData.some(string => {
          const content = sanitizeAllHTML(string);
          return content.toLocaleLowerCase().includes(message.toLocaleLowerCase());
        });
      });
      setDataSets(filterDatasets);
    } else {
      setDataSets(data);
    }
  }, [message]);

  const renderImportButton = (cellValue, row) => {
    return <ImportButton csvFilePath={cellValue} onImportClick={() => onChange(cellValue, row)} />;
  };

  const columnConfigs = {
    download: {
      alias: IMPORT,
      align: TableCellAlign.center,
      formatter: renderImportButton
    },
    pednotes: {
      alias: PEDAGOGICAL_NOTES
    },
    samplesize: {
      alias: N,
      isSortable: true
    },
    name: {
      isSortable: true
    }
  };

  if (data.length === 0) {
    return (
      <div className="loader">
        <LoadingIndicator />
      </div>
    );
  }

  /* Inline style used to Override React Magma Table CSS Value*/
  return (
    <AccordionTable
      keyColumn="name"
      rows={dataSets}
      columnConfigs={columnConfigs}
      order={order}
      style={{ 'border': '1px solid #DFDFDF', 'width': '100%' }}
      hiddenColumns={hiddenColumns}
      HiddenColumnsComponent={HiddenColumns}
      className="dataset-table"
      testId="datasetHub-table"
      messageForEmptyTable="No matching records found"
    />
  );
};

DatasetTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
};

export default DatasetTable;

